import { Page } from "@components";

export const RevitPluginScreen: React.FC<any> = () => (
  <Page title="Revit plugin"></Page>
);
